import { useNavigate } from 'react-router-dom';

const Main = ({ children }: any) => {
    const navigate = useNavigate();

    return (
      <div className="bg-gray-100 flex">
        {children}
      </div>
    );
};

export default Main;